module.exports = __webpack_public_path__ + "img/角色统计.45db6fd7.svg";